<template>
  <v-row dense>
    <v-col class="mx-n3">
      <div id="chart" class="mt-14">
        <apexchart
          type="area"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import moment from "moment";

export default {
  components: { apexchart: VueApexCharts },
  props: {
    dataTmc: Array,
    dataTma: Array,
    dataTme: Array,
    dataCategories: Object,
  },

  data: () => ({
    series: [
      { name: "TMC", data: [] },
      { name: "TMA", data: [] },
      { name: "TME", data: [] },
    ],
    chartOptions: {
      colors: ["#66BB6A", "#EF5350", "#FDD835"],
      title: {
        text: "Tempos de Atendimento por Dia",
        align: "left",
        style: {
          fontFamily: "Roboto_700Bold",
          fontSize: "24px",
        },
      },
      chart: {
        height: 350,
        type: "area",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      tooltip: {
        y: {
          formatter: (value) => {
            if (value >= 60) {
              var minutes = Math.floor(value / 60);
              const secs = String(value % 60).padStart(2, "0");
              const hours = String(Math.floor(minutes / 60)).padStart(2, "0");
              minutes = String(minutes % 60).padStart(2, "0");

              return `${hours}:${minutes}:${secs}`;
            } else {
              return moment(value, "ss").format("HH:mm:ss");
            }
          },
        },
      },
      yaxis: {
        labels: {
          formatter: (value) => {
            if (value >= 60) {
              var minutes = Math.floor(value / 60);
              const secs = String(value % 60).padStart(2, "0");
              const hours = String(Math.floor(minutes / 60)).padStart(2, "0");
              minutes = String(minutes % 60).padStart(2, "0");

              return `${hours}:${minutes}:${secs}`;
            } else {
              return moment(value, "ss").format("HH:mm:ss");
            }
          },
        },
      },
      xaxis: {
        type: "category",
        categories: [],
      },
    },
  }),

  watch: {
    dataTmc: {
      deep: true,
      immediate: true,
      handler() {
        this.series[0].data = this.dataTmc.map((tmc) =>
          moment.duration(tmc).asSeconds()
        );
        this.series.splice(0, 1, this.series[0]);
      },
    },

    dataTma: {
      deep: true,
      immediate: true,
      handler() {
        this.series[1].data = this.dataTma.map((tma) =>
          moment.duration(tma).asSeconds()
        );
        this.series.splice(0, 1, this.series[0]);
      },
    },

    dataTme: {
      deep: true,
      immediate: true,
      handler() {
        this.series[2].data = this.dataTme.map((tme) =>
          moment.duration(tme).asSeconds()
        );
        this.series.splice(0, 1, this.series[0]);
      },
    },

    dataCategories: {
      deep: true,
      immediate: true,
      handler() {
        const valoresXaxis = [...this.dataCategories.dataCategory];
        this.chartOptions = {
          colors: ["#66BB6A", "#EF5350", "#FDD835"],
          title: {
            text: this.dataCategories.title,
            align: "left",
            style: {
              // fontFamily: 'Roboto_700Bold',
              fontFamily: "sans-serif",
              fontWeight: "bold",
              fontSize: "23px",
              color: "darkenGray",
            },
          },
          chart: {
            height: 250,
            type: "area",
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          tooltip: {
            y: {
              formatter: function(value) {
                if (value >= 60) {
                  var minutes = Math.floor(value / 60);
                  const secs = String(value % 60).padStart(2, "0");
                  const hours = String(Math.floor(minutes / 60)).padStart(
                    2,
                    "0"
                  );
                  minutes = String(minutes % 60).padStart(2, "0");

                  return `${hours}:${minutes}:${secs}`;
                } else {
                  return moment(value, "ss").format("HH:mm:ss");
                }
              },
            },
          },
          yaxis: {
            labels: {
              formatter: (value) => {
                if (value >= 60) {
                  var minutes = Math.floor(value / 60);
                  const secs = String(value % 60).padStart(2, "0");
                  const hours = String(Math.floor(minutes / 60)).padStart(
                    2,
                    "0"
                  );
                  minutes = String(minutes % 60).padStart(2, "0");

                  return `${hours}:${minutes}:${secs}`;
                } else {
                  return moment(value, "ss").format("HH:mm:ss");
                }
              },
            },
          },
          xaxis: {
            type: "category",
            categories: valoresXaxis,
          },
        };
      },
    },
  },
};
</script>
